
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 14c-4.72 0-9.5 2-10 4.59a.5.5 0 01-.49.41h-.1a.46.46 0 01-.32-.13.498.498 0 01-.09-.33A11.22 11.22 0 0114 8V5.42a.488.488 0 01.15-.36l.2-.2a.5.5 0 01.71 0l5.79 5.79a.477.477 0 010 .7l-5.79 5.79a.5.5 0 01-.71 0l-.2-.2a.488.488 0 01-.15-.36V14z"}})])
          )
        }
      }
    